import React from 'react'
import {Form} from 'antd'

import useFormContext from './useFormContext'

export default ({fieldName, rules, initialValue, children}) => (
  <Form.Item>
    {useFormContext().getFieldDecorator(fieldName, {
      rules: rules ? rules : [],
      initialValue: initialValue ? initialValue : undefined,
    })(children)}
  </Form.Item>
)
